<template>
  <v-app id="lg">
    <Header />
    <v-main>
      <v-container class="mt-10" fluid>
        <v-row align="center" justify="center">
          <v-card flat max-width="100%">
            <v-card-title class="justify-center">
              <h2>システムで処理できないエラーが発生しました。</h2>
            </v-card-title>
            <v-card-text>
              <div class="text-center">大変お手数ではございますが、再度実行頂き、問題が回復しない場合は、</div>
              <div class="text-center">サポート窓口までお問い合わせ頂けますようお願い申し上げます。</div>
              <div class="text-center">
                <a id="toLogin" href="/login">ログイン画面へ戻る</a>
              </div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
  components: {
    Header,
    Footer,
  },
  created: function () {
    this.$cookies.remove('access_token');
  },
};
</script>
